import { Col, Row } from "antd";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import React, { useEffect, useState, FC, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { FiSave, FiX } from "react-icons/fi";
import { useUserContext } from "../../../Context/UserContext";
import { ProgressBar } from "primereact/progressbar";
import { GetDepartment } from "../../../Services/DepartmentService";
import { GetAllDynamic } from "../../../Services/DynamicService";
import {
  GetAllEmployee,
  GetUserData,
  UpdateEmployee,
  UpdateSignature,
} from "../../../Services/EmployeeService";
import { GetAllPosition } from "../../../Services/PositionService";
import { SelectDataDialog } from "../../Select/SelectionDataDialog/SelectDataDialog";
import { TextHeaderComponents } from "../../TextHeaderComponents/TextHeaderComponents";
import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { IUserModel } from "../../../IRequestModel/IUserModel";
import { CheckCanEditProfile } from "../../../Services/AppSettingService";
import useAlert from "../../../hooks/useAlert";
import { useTranslation } from "react-i18next";

type Props = {
  rowData: any;
  dialogHeader: string;
  mainDialogVisible?: boolean;
  toggleMainDialog: (state: boolean, action: string) => void;
  tableData?: any;
  setMainLoading?: (bool: boolean) => void;
  setTableData?: (items: any) => void;
  canEditOnlySignature?: boolean;
  isEditProfile?: boolean;
};

interface IEmployeeForm {
  EmployeeId: number;
  EmployeeCode: string;
  Username: string;
  NameTh: string;
  NameEn: string;
  Email: string;
  IsActive: boolean;
  PositionId: number;
  PositionNameTh: string;
  PositionNameEn: string;
  DepartmentId: number;
  DepartmentNameTh: string;
  DepartmentNameEn: string;
  DepartmentCode: string;
  DivisionId: number | null;
  DivisionNameTh: string;
  DivisionNameEn: string;
  DivisionCode: string;
  ReportToEmpCode: string;
  SignPicPath: string;
  Lang: string;
  AccountCode: string;
  AccountName: string;
  DefaultLang: string;
  CreatedDate: string;
  CreatedBy: string;
  ModifiedDate: string;
  ModifiedBy: string;
  ADTitle: string;
  SectionCode: string | null;
  SectionId: number | null;
  SectionName: string | null;
}

const EmployeeDialogFix: FC<Props> = ({
  rowData,
  dialogHeader,
  mainDialogVisible,
  toggleMainDialog,
  tableData,
  setTableData,
  setMainLoading,
  canEditOnlySignature,
  isEditProfile,
}) => {
  const [positionList, setPositionList] = useState<any[]>([]);
  const [departmentList, setDepartmentList] = useState<any[]>([]);
  const [divisionData, setDivisionData] = useState<any[]>([]);
  const [divisionList, setDivisionList] = useState<any[]>([]);
  const [sectionList, setSectionList] = useState<any[]>([]);
  const [sectionData, setSectionData] = useState<any[]>([]);
  const [dataEmployeeList, setDataEmployeeList] = useState<any[]>([]);
  const [subDialogVisible, setSubDialogVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [action, setAction] = useState<string>("");
  const [uploadFile, setUploadFile] = useState<any>();
  const [userData, setUserData] = useUserContext();
  const [messageConfirmDialog, setMessageConfirmDialog] = useState("");
  const [editProfileSetting, setEditProfileSetting] = useState<any>();
  const toast = useRef<any>(null);
  const { i18n } = useTranslation(["translation"]);
  const { toggleAlert } = useAlert();
  let defaultValues: IEmployeeForm = {
    EmployeeId: 0,
    EmployeeCode: "",
    Username: "",
    NameTh: "",
    NameEn: "",
    Email: "",
    IsActive: true,
    PositionId: 0,
    PositionNameTh: "",
    PositionNameEn: "",
    DepartmentId: 0,
    DepartmentNameTh: "",
    DepartmentNameEn: "",
    DepartmentCode: "",
    DivisionId: null,
    DivisionNameTh: "",
    DivisionNameEn: "",
    DivisionCode: "",
    ReportToEmpCode: "",
    SignPicPath: "",
    Lang: "",
    AccountCode: "",
    AccountName: "",
    DefaultLang: "",
    CreatedDate: "",
    CreatedBy: "",
    ModifiedDate: "",
    ModifiedBy: "",
    ADTitle: "",
    SectionCode: null,
    SectionId: null,
    SectionName: null,
  };
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    watch,
    reset,
    setValue,
    setError,
    formState: { errors },
  } = useForm<IEmployeeForm>({
    defaultValues,
  });

  const watchDepartmentId = watch("DepartmentId");
  const watchDivisionId = watch("DivisionId");

  useEffect(() => {
    // not department value
    if (!watchDepartmentId) return;

    const dept = departmentList.find(
      (d: any) => d.DepartmentId === watchDepartmentId,
    );
    if (!dept) return;

    //  filter division
    const divList = divisionData.filter(
      (d: any) => d.DepartmentCode === dept.DepartmentCode,
    );
    setDivisionList(divList);

    //  filter section
    let secList = sectionData.filter(
      (s: any) => s.DepartmentCode === dept.DepartmentCode,
    );

    if (watchDivisionId) {
      const div = divisionData.find(
        (d: any) => d.DivisionId === watchDivisionId,
      );
      if (div) {
        secList = secList.filter(
          (s: any) => s.DivisionCode === div.DivisionCode,
        );
      }
    }

    setSectionList(secList);
  }, [
    watchDepartmentId,
    watchDivisionId,
    departmentList,
    divisionData,
    sectionData,
  ]);

  useEffect(() => {
    if (action === "edit" && departmentList.length > 0) {
      setValue("DepartmentId", rowData.DepartmentId);
      setValue("DivisionId", rowData.DivisionId);
      setValue("SectionId", rowData.SectionId);
    }
  }, [action, departmentList]);

  useEffect(() => {
    if (mainDialogVisible) {
      if (dialogHeader === "Edit Profile") {
        setAction("edit");
      } else if (dialogHeader === "Employee") {
        setAction("edit");
      } else {
        setAction("add");
      }
    } else {
      setUploadFile(undefined);
    }
  }, [mainDialogVisible]);

  useEffect(() => {
    setMessageConfirmDialog("Do you want to " + action + " this record?");
  }, [action]);

  const acceptSave = async (data: IEmployeeForm) => {
    const lang = data.Lang === "EN" ? "en" : "th";
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", data.Lang);

    const now = new Date().toLocaleString("en-UK", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

    const selectedPosition = positionList.find(
      (p) => p.PositionId === data.PositionId,
    );
    const selectedDept = departmentList.find(
      (d) => d.DepartmentId === data.DepartmentId,
    );
    const selectedDivision = divisionData.find(
      (d) => d.DivisionId === data.DivisionId,
    );
    const selectedSection = sectionData.find(
      (s) => s.SectionId === data.SectionId,
    );
    const selectedEmp = dataEmployeeList.find(
      (e) => e.EmployeeId == data.ReportToEmpCode,
    );

    const basePayload = {
      Username: data.Username,
      EmployeeCode: data.EmployeeCode,
      NameTh: data.NameTh,
      NameEn: data.NameEn,
      Email: data.Email,
      Lang: data.Lang,

      PositionId: selectedPosition?.PositionId,
      PositionNameTh: selectedPosition?.NameTh,
      PositionNameEn: selectedPosition?.NameEn,

      DepartmentId: selectedDept?.DepartmentId,
      DepartmentNameTh: selectedDept?.NameTh,
      DepartmentNameEn: selectedDept?.NameEn,
      DepartmentCode: selectedDept?.DepartmentCode,

      DivisionId: selectedDivision?.DivisionId,
      DivisionNameTh: selectedDivision?.NameTh,
      DivisionNameEn: selectedDivision?.NameEn,
      DivisionCode: selectedDivision?.DivisionCode,

      SectionId: selectedSection?.SectionId,
      SectionCode: selectedSection?.SectionCode,

      ReportToEmpCode: selectedEmp?.EmployeeId?.toString(),
    };

    const formData =
      action === "add"
        ? {
            ...basePayload,
            EmployeeId: 0,
            IsActive: data.IsActive,
            CreatedDate: now,
            CreatedBy: userData.EmployeeId.toString(),
            ModifiedDate: now,
            ModifiedBy: userData.EmployeeId.toString(),
          }
        : {
            ...rowData,
            ...basePayload,
            IsActive:
              dialogHeader === "Edit Profile" ? true : (data.IsActive ?? false),
            ModifiedDate: now,
            ModifiedBy: userData.EmployeeId.toString(),
          };

    if (uploadFile !== undefined) {
      formData.SignPicPath = uploadFile;
    }

    const result = await UpdateEmployee(formData);

    if (result.result === "success") {
      if (dialogHeader === "Edit Profile") {
        setUserData({ ...(formData as IUserModel) });
      } else if (setTableData) {
        const newData = await GetAllDynamic("Employee/GetAll", undefined);
        if (newData?.length) setTableData(newData);
      }

      toggleMainDialog(false, "save");
    } else {
      toggleAlert({
        message: "Error",
        description: result.errorMessage || result.title,
        type: "error",
      });
    }

    setLoading(false);
  };

  const onSubmit = (data: IEmployeeForm) => {
    confirmDialog({
      message: messageConfirmDialog,
      header:
        action === "add" ? "Add" + " Confirmation" : "Edit" + " Confirmation",
      icon: "p-confirm-dialog-icon pi pi-info-circle",
      acceptClassName:
        "p-button p-component p-confirm-dialog-accept table-accept p-button-success table-control-confirm-button p-button-accept-cancel",
      accept: () => {
        // if (dialogHeader !== "Edit Profile") {
        //   toggleMainLoading();
        // } else {
        setLoading(true);
        // }
        acceptSave(data);
      },
    });
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);

      await fetchDepartment();
      await fetchDivision();
      await fetchSection();
      await fetchPosition();
      await getSetting();
      await fetchDataEmployee();

      setLoading(false);
    };

    init();
  }, []);


  const getSetting = async () => {
    const canEditProfile = await CheckCanEditProfile();

    setEditProfileSetting(canEditProfile);
  };

  async function fetchPosition() {
    let _dataPosition = await GetAllDynamic("Position/GetAll", undefined);
    if (_dataPosition) {
      _dataPosition.map((e: any) => {
        if (!e.CompanyCode) {
          e.NameEn = e.NameEn;
          e.NameTh = e.NameTh;
          return e;
        }
        e.NameEn = e.CompanyCode + " : " + e.NameEn;
        e.NameTh = e.CompanyCode + " : " + e.NameTh;
        return e;
      });
    }

    setPositionList(_dataPosition?.filter((e: any) => e.IsActive));
  }

  async function fetchDataEmployee() {
    setLoading(true);

    let user: any = null;
    let sectionFromUser: any = null;

    if (rowData?.EmployeeId) {
      const data = {
        EmployeeId: String(rowData.EmployeeId),
      };

      user = await GetUserData(data);

      if (user) {
        setUploadFile(user.SignPicPath);
        setSelectedEmployee(user);
      }

      sectionFromUser = user?.MSTSections?.find(
        (s: any) => String(s.SectionID) === String(user.SectionId)
      );
    }

    const _dataEmployee = await GetAllEmployee({ Scopes: "name,email,org" });

    if (_dataEmployee) {
      const list = _dataEmployee
        .filter((e: any) => e.IsActive)
        .map((e: any) => {
          if (user && String(e.EmployeeId) === String(user.EmployeeId)) {
            return {
              ...e,
              DepartmentCode: sectionFromUser?.DepartmentCode,
              DivisionCode: sectionFromUser?.DivisionCode,
              SectionId: sectionFromUser?.SectionID,
              SectionCode: sectionFromUser?.SectionCode,
            };
          }
          return e;
        });
      
      setDataEmployeeList(list);
    }

    setLoading(false);
  }

  useEffect(() => {
    if (
      selectedEmployee &&
      departmentList.length &&
      divisionData.length &&
      sectionData.length
    ) {
      reset({
        ...selectedEmployee,
        DepartmentId: selectedEmployee.DepartmentId ?? null,
        DivisionId: selectedEmployee.DivisionId ?? null,
        SectionId: selectedEmployee.SectionId ?? null,
      });
    }
  }, [selectedEmployee, departmentList, divisionData, sectionData, reset]);


  async function fetchDepartment() {
    try {
      const data: any[] = await GetDepartment();

      const activeDepartments = data
        .filter((e: any) => e.IsActive)
        .map((e: any) => ({
          ...e,
          NameEn: e.CompanyCode ? `${e.CompanyCode} : ${e.NameEn}` : e.NameEn,
          NameTh: e.CompanyCode ? `${e.CompanyCode} : ${e.NameTh}` : e.NameTh,
        }));

      setDepartmentList(activeDepartments);
    } catch (error) {
      console.error("fetchDepartment error:", error);
    }
  }

  async function fetchDivision() {
    try {
      const data: any[] = await GetAllDynamic("Division/GetAll", undefined);

      const activeDivisions = data
        .filter((e: any) => e.IsActive)
        .map((e: any) => ({
          ...e,
          NameEn: e.DivisionCode ? `${e.DivisionCode} : ${e.NameEn}` : e.NameEn,
          NameTh: e.DivisionCode ? `${e.DivisionCode} : ${e.NameTh}` : e.NameTh,
        }));

      setDivisionData(activeDivisions);
      setDivisionList(activeDivisions);
    } catch (error) {
      console.error("fetchDivision error:", error);
    }
  }

  async function fetchSection() {
    try {
      let _dataSection: any[] = await GetAllDynamic(
        "Section/GetAll",
        undefined,
      );

      const result = _dataSection
        .filter(
          (e: any) =>
            e.IsActive === true &&
            e.SectionCode !== null &&
            e.SectionCode !== undefined &&
            e.SectionCode !== "",
        )
        .map((e: any) => ({
          ...e,
          SectionId: Number(e.SectionID),
          SectionName: `${e.SectionCode} : ${e.SectionName}`,
        }));

      setSectionData(result);
      setSectionList(result);
    } catch (error) {
      console.error(error);
    }
  }

  const getReportTo = (currentCode: any) => {
    let val = "";
    if (currentCode) {
      const emp = dataEmployeeList.find(
        (e: any) => e.EmployeeId == currentCode,
      );
      if (emp) {
        if (userData?.Lang === "EN") {
          val = emp.NameEn;
        } else {
          val = emp.NameTh;
        }
      }
    }
    return val;
  };

  const onFileSelect = (e: any) => {
    const validTypes = ["image/png", "image/jpeg"];

    if (
      e.target.files[0].size <= Number(editProfileSetting?.limitFileSize) &&
      validTypes?.includes(e?.target?.files[0]?.type)
    ) {
      getBase64(e.target.files[0]);
    } else if (!validTypes?.includes(e?.target?.files[0]?.type)) {
      toggleAlert({
        description: `Please select a PNG or JPG image.`,
        message: `File type warning.`,
        type: "warning",
      });
    } else {
      toggleAlert({
        description: `File upload limit 20 MB (20,971,520 bytes) per file.`,
        message: `File size warning.`,
        type: "warning",
      });
      // toast.current?.show({
      //   severity: "error",
      //   summary: "Error Message",
      //   detail: "File upload limit 20 MB (20,971,520 bytes) per file.",
      //   life: 5000,
      // });
    }
  };

  const getFormErrorMessage = (name: string) => {
    const errs: any = control._formState.errors;
    if (errs[name]) {
      if (errs[name].type === "required") {
        return <small className="p-error">{errs[name].message}</small>;
      } else if (
        !!errs[name].message &&
        errs[name].message.match(/^customPosition:/)
      ) {
        return (
          <small className="p-error">
            {errs[name].message?.replace("customPosition:", "")}
          </small>
        );
      } else if (
        !!errs[name].message &&
        errs[name].message.match(/^customDepartment:/)
      ) {
        return (
          <small className="p-error">
            {errs[name].message?.replace("customDepartment:", "")}
          </small>
        );
      } else {
        return (
          <small className="p-error">
            {"This " + name + " is not the correct pattern"}
          </small>
        );
      }
    }
  };

  function getBase64(file: any) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setUploadFile(reader.result);
    };
    reader.onerror = function (error) {};
  }

  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        visible={mainDialogVisible}
        header={dialogHeader}
        breakpoints={{}}
        style={{ width: "85%", borderRadius: "16px", maxWidth: "1000px" }}
        baseZIndex={99999}
        modal
        className="p-fluid"
        onHide={() => {
          if (toggleMainDialog) {
            toggleMainDialog(false, "close");
          }
        }}
        draggable={false}
        blockScroll
      >
        <>
          {loading ? (
            <ProgressBar
              mode="indeterminate"
              style={{ height: "6px" }}
            ></ProgressBar>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row gutter={[10, 10]}>
                <Col span={24}>
                  <Row gutter={{ xs: 24, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Employee Code"}
                        textSubProps={"รหัสพนักงาน"}
                        isRequir
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={8}>
                      <Controller
                        name="EmployeeCode"
                        control={control}
                        rules={{ required: "Employee Code is required." }}
                        render={({
                          field,
                          fieldState,
                          formState: { errors, isSubmitted },
                        }) => (
                          <InputText
                            id={field.name}
                            {...field}
                            disabled={
                              canEditOnlySignature
                                ? canEditOnlySignature
                                : undefined
                            }
                            maxLength={editProfileSetting?.EmployeeCodeSize}
                            autoFocus
                            className={classNames({
                              "p-invalid": !control._getWatch(field.name),
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("EmployeeCode")}
                    </Col>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Username"}
                        textSubProps={"ชื่อผู้ใช้"}
                        isRequir
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={8}>
                      <Controller
                        name="Username"
                        control={control}
                        rules={{ required: "Username is required." }}
                        render={({ field, fieldState }) => (
                          <InputText
                            id={field.name}
                            {...field}
                            disabled={
                              canEditOnlySignature
                                ? canEditOnlySignature
                                : undefined
                            }
                            className={classNames({
                              "p-invalid": !control._getWatch(field.name),
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("Username")}
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 24, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Name TH"}
                        textSubProps={"ชื่อภาษาไทย"}
                        isRequir
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={8}>
                      <Controller
                        name="NameTh"
                        control={control}
                        rules={{ required: "NameTH is required." }}
                        render={({ field, fieldState }) => (
                          <InputText
                            id={field.name}
                            {...field}
                            disabled={
                              canEditOnlySignature
                                ? canEditOnlySignature
                                : undefined
                            }
                            className={classNames({
                              "p-invalid": !control._getWatch(field.name),
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("NameTh")}
                    </Col>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Name EN"}
                        textSubProps={"ชื่อภาษาอังกฤษ"}
                        isRequir
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={8}>
                      <Controller
                        name="NameEn"
                        control={control}
                        rules={{ required: "NameEN is required." }}
                        render={({
                          field,
                          fieldState,
                          formState: { errors, isSubmitted },
                        }) => (
                          <InputText
                            id={field.name}
                            {...field}
                            disabled={
                              canEditOnlySignature
                                ? canEditOnlySignature
                                : undefined
                            }
                            className={classNames({
                              "p-invalid": !control._getWatch(field.name),
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("NameEn")}
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 24, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Email"}
                        textSubProps={"อีเมล"}
                        isRequir
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={8}>
                      <Controller
                        name="Email"
                        control={control}
                        rules={{
                          required: "Email is required.",
                          pattern:
                            /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/g,
                        }}
                        render={({
                          field,
                          fieldState,
                          formState: { errors },
                        }) => (
                          <InputText
                            id={field.name}
                            {...field}
                            disabled={
                              canEditOnlySignature
                                ? canEditOnlySignature
                                : undefined
                            }
                            className={classNames({
                              "p-invalid": !control._getWatch(field.name),
                            })}
                          />
                        )}
                      />
                      {getFormErrorMessage("Email")}
                    </Col>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Language"}
                        textSubProps={"ภาษา"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={8}>
                      <Controller
                        name="Lang"
                        control={control}
                        render={({ field, fieldState }) => (
                          <Dropdown
                            id={field.name}
                            {...field}
                            disabled={
                              canEditOnlySignature
                                ? canEditOnlySignature
                                : undefined
                            }
                            options={["TH", "EN"]}
                            placeholder="Select a Lang"
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 24, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Active Status"}
                        textSubProps={"สถานะ"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={4}>
                      <Controller
                        name="IsActive"
                        control={control}
                        render={({ field, fieldState }) => (
                          <InputSwitch
                            id={field.name}
                            checked={field.value}
                            disabled={
                              canEditOnlySignature
                                ? canEditOnlySignature
                                : undefined
                            }
                            onChange={(e: any) => {
                              field.onChange(e.value);
                            }}
                            className={classNames({
                              "p-invalid": !control._getWatch(field.name),
                            })}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 24, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Position"}
                        textSubProps={"ตำแหน่ง"}
                        isRequir
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                      <Controller
                        name="PositionId"
                        control={control}
                        rules={{
                          required: "Position is required.",
                          min: {
                            value: 1,
                            message: "customPosition:Position is required.",
                          },
                        }}
                        defaultValue={0}
                        render={({ field, fieldState }) => {
                          return (
                            <Dropdown
                              // value={formSelectedPosition}
                              options={positionList}
                              optionLabel={
                                userData.Lang === "EN" ? "NameEn" : "NameTh"
                              }
                              filter
                              showClear
                              filterBy={
                                userData.Lang === "EN" ? "NameEn" : "NameTh"
                              }
                              disabled={
                                canEditOnlySignature
                                  ? canEditOnlySignature
                                  : undefined
                              }
                              id={field.name}
                              value={positionList.find(
                                (pos: any) => pos.PositionId === field.value
                              )}
                              onChange={(e: any) => {
                                if (e.value) {
                                  field.onChange(e.value.PositionId);
                                } else {
                                  field.onChange(null);
                                }
                              }}
                              className={classNames({
                                "p-invalid": !control._getWatch(field.name),
                              })}
                            />
                          );
                        }}
                      />
                      {getFormErrorMessage("PositionId")}
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 24, sm: 16, md: 24, lg: 24 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Department"}
                        textSubProps={"หน่วยงาน"}
                        isRequir
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                      <Controller
                        name="DepartmentId"
                        control={control}
                        rules={{
                          required: "Department is required.",
                          min: {
                            value: 1,
                            message: "customDepartment:Department is required.",
                          },
                        }}
                        defaultValue={0}
                        render={({ field, fieldState }) => {
                          return (
                            <Dropdown
                              // value={formSelectedPosition}
                              options={departmentList}
                              optionLabel={
                                userData.Lang === "EN" ? "NameEn" : "NameTh"
                              }
                              filter
                              disabled={
                                canEditOnlySignature
                                  ? canEditOnlySignature
                                  : undefined
                              }
                              showClear
                              filterBy={
                                userData.Lang === "EN" ? "NameEn" : "NameTh"
                              }
                              id={field.name}
                              value={departmentList.find(
                                (dept: any) =>
                                  dept.DepartmentId === field.value,
                              )}
                              onChange={(e) => {
                                field.onChange(e.value?.DepartmentId ?? null);
                                setValue("DivisionId", null);
                                setValue("SectionId", null);
                              }}
                              className={classNames({
                                "p-invalid": !control._getWatch(field.name),
                              })}
                            />
                          );
                        }}
                      />
                      {getFormErrorMessage("DepartmentId")}
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Division"}
                        textSubProps={"ฝ่ายงาน"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                      <Controller
                        name="DivisionId"
                        control={control}
                        render={({ field, fieldState }) => (
                          <Dropdown
                            // value={formSelectedPosition}
                            options={divisionList}
                            optionLabel={
                              userData.Lang === "EN" ? "NameEn" : "NameTh"
                            }
                            filter
                            showClear
                            // disabled={
                            //   canEditOnlySignature
                            //     ? canEditOnlySignature
                            //     : undefined
                            // }
                            disabled={
                              !watch("DepartmentId") || canEditOnlySignature
                            }
                            filterBy={
                              userData.Lang === "EN" ? "NameEn" : "NameTh"
                            }
                            id={field.name}
                            value={divisionList?.find(
                              (div: any) => div.DivisionId === field.value,
                            )}
                            onChange={(e) => {
                              field.onChange(e.value?.DivisionId ?? null);
                              setValue("SectionId", null);
                            }}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Section"}
                        textSubProps={"ฝ่ายงาน"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                      <Controller
                        name="SectionId"
                        control={control}
                        render={({ field }) => (
                          <Dropdown
                            options={sectionList}
                            optionLabel="SectionName"
                            filter
                            showClear
                            disabled={
                              !watch("DepartmentId") || canEditOnlySignature
                            }
                            value={sectionList.find(
                              (s) => s.SectionId === field.value,
                            )}
                            onChange={(e) =>
                              field.onChange(e.value ? e.value.SectionId : null)
                            }
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Report to"}
                        textSubProps={"รายงานไปที่"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                      <Controller
                        name="ReportToEmpCode"
                        control={control}
                        render={({ field, fieldState }) => (
                          <div className="p-inputgroup">
                            <InputText
                              id={field.name}
                              value={getReportTo(field.value)}
                              className={classNames({
                                "p-invalid": fieldState.invalid,
                              })}
                              disabled={
                                canEditOnlySignature
                                  ? canEditOnlySignature
                                  : undefined
                              }
                              style={{
                                borderRadius: "6px 0 0 6px",
                                height: "38px",
                              }}
                              readOnly
                            />
                            {control._getWatch(field.name) && (
                              <Button
                                type="button"
                                icon="pi pi-times"
                                className="p-button-danger p-button-danger-hover"
                                onClick={() => {
                                  setValue("ReportToEmpCode", "");
                                }}
                                disabled={
                                  canEditOnlySignature
                                    ? canEditOnlySignature
                                    : undefined
                                }
                                style={{
                                  height: "38px",
                                }}
                              />
                            )}
                            <Button
                              icon="pi pi-search"
                              className="p-button-text-position p-button-text-position-hover "
                              style={{
                                backgroundColor: "#282f6a",
                                border: "1px solid #282f6a",
                                borderTopRightRadius: "6px",
                                borderBottomRightRadius: "6px",
                                boxShadow: "none",
                                height: "38px",
                              }}
                              disabled={
                                canEditOnlySignature
                                  ? canEditOnlySignature
                                  : undefined
                              }
                              type={"button"}
                              onClick={() => {
                                setSubDialogVisible(true);
                              }}
                            />
                          </div>
                        )}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col xs={24} sm={24} md={10} lg={4} xl={4}>
                      <TextHeaderComponents
                        textHeaderProps={"Signature"}
                        textSubProps={"ลายเซ็น"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={20} xl={20}>
                      <Controller
                        name="SignPicPath"
                        control={control}
                        render={({ field, fieldState }) => (
                          <div className="p-inputgroup">
                            <InputText
                              type="file"
                              accept="image/*"
                              id="formFile"
                              onChange={onFileSelect}
                              style={{
                                borderRadius: "6px 0 0 6px",
                                width: "38px",
                                height: "38px",
                              }}
                            />
                            <Button
                              type="reset"
                              icon="pi pi-times"
                              className="p-button-danger p-button-danger-hover"
                              onClick={() => {
                                console.log(555);

                                setUploadFile("");
                              }}
                              style={{
                                width: "38px",
                                height: "38px",
                                borderRadius: "0 6px 6px 0",
                              }}
                            />
                          </div>
                        )}
                      />
                      {uploadFile && uploadFile !== "" && (
                        <div className="image-box">
                          <img className="table-img" src={uploadFile} />
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col span={4}></Col>
                    <Col span={20}>
                      <p
                        className="content-text-detail"
                        style={{ overflowWrap: "break-word" }}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: editProfileSetting?.limitFileInfo,
                          }}
                        />
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="footer-dialog">
                <button
                  onClick={() => {
                    confirmDialog({
                      message: "Are you sure you want to cancel this action?",
                      header: "Cancel Confirmation",
                      icon: "p-confirm-dialog-icon pi pi-info-circle",
                      acceptClassName:
                        "p-button p-component p-confirm-dialog-accept table-accept p-button-danger table-control-confirm-button p-button-accept-cancel",
                      accept: () => {
                        reset();
                        toggleMainDialog(false, "close");
                      },
                    });
                  }}
                  type={"button"}
                  className="button-cancle"
                >
                  <FiX />
                  Close
                </button>

                <button className="button-save" type="submit">
                  <FiSave />
                  Save
                </button>
              </div>
            </form>
          )}
        </>
      </Dialog>
      <SelectDataDialog
        dialogKey={"Employee"}
        dataList={dataEmployeeList}
        onSelectFunc={(e: any) => {
          setValue("ReportToEmpCode", e.EmployeeId.toString());
          setSubDialogVisible(false);
        }}
        columns={[
          {
            field: "EmployeeCode",
            headerEn: "EmployeeCode",
            headerTh: "รหัสพนักงาน",
          },
          {
            field: "NameEn",
            headerEn: "Name",
            headerTh: "ชื่อ",
          },
          {
            field: "PositionNameEn",
            headerEn: "Position",
            headerTh: "ตำแหน่ง",
          },
          {
            field: "DepartmentNameEn",
            headerEn: "Department",
            headerTh: "หน่วยงาน",
          },
        ]}
        dialogVisible={subDialogVisible}
        setDialogVisible={setSubDialogVisible}
      />
    </div>
  );
};

export default EmployeeDialogFix;
